// @flow
import * as React from 'react';
import { FollowUps } from './follow-ups';
import { useParams } from 'react-router-dom';
import { keycloak } from '@coverright/shared/keycloak';
import { useOutdatedFollowUps } from '../../hooks/use-outdated-follow-ups';
import { dataSource } from '../../lib/emulated-data-source';

export const OutdatedFollowUps = () => {
  const {agentId} = useParams<{ agentId?: string }>();
  const outdated = useOutdatedFollowUps(agentId)

  return (
    <FollowUps title={'Outdated Follow-Ups'}
               suffix={'Outdated'}
               dataSource={dataSource('followUps', outdated)}
               agent={agentId || keycloak?.tokenParsed?.sub} />
  );
};

